"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const rxjs_1 = require("rxjs");
class Command {
    constructor(description, executionF, unexecutionF = () => rxjs_1.EMPTY) {
        this.description = description;
        this.executionF = executionF;
        this.unexecutionF = unexecutionF;
    }
    execution() { return this.executionF(this); }
    unexecution() { return this.unexecutionF(this); }
}
exports.Command = Command;
Command.NOP = new Command('NOP', () => rxjs_1.EMPTY);
function commandCompose(...commands) {
    // LEARN: Composing easy!
    return new Command(commands.join("|"), () => rxjs_1.zip(...commands.map(c => c.execution())), () => rxjs_1.zip(...commands.map(c => c.unexecution())));
}
exports.commandCompose = commandCompose;
function commandComposeAny(...commands) {
    // LEARN: Composing easy!
    return new Command(commands.join("|"), () => rxjs_1.zip(...commands.map(c => c.execution())), () => rxjs_1.zip(...commands.map(c => c.unexecution())));
}
exports.commandComposeAny = commandComposeAny;
